import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ClockRewindIcon } from 'app/components/shared/icons';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';

import { ResourcesNLPSearchContext } from '../../ResourcesNLPSearchContext';
import useResourcesSearchHistory from '../../useResourcesSearchHistory';
import {
  ResourcesNLPSearchBarHistoryClearButtonContainer,
  ResourcesNLPSearchBarHistoryClearCTA,
  ResourcesNLPSearchBarHistoryItem,
  ResourcesNLPSearchBarHistoryItemDate,
  ResourcesNLPSearchBarHistoryItemLabel,
  ResourcesNLPSearchBarHistoryList,
  ResourcesNLPSearchBarHistoryWrapper,
} from './styled';

export default function ResourcesNLPSearchBarHistory() {
  const dispatch = useDispatch();
  const context = useContext(ResourcesNLPSearchContext);
  const { getSearches, clearSearches } = useResourcesSearchHistory();

  const groupedSearches = useMemo(() => {
    const searches = getSearches();

    return searches.reduce((acc, search) => {
      const date = new Date(search.timestamp);
      const key = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      acc[key] = acc[key] || [];
      acc[key].push(search);

      return acc;
    }, {});
  }, [getSearches]);

  const handleClearHistory = () => {
    clearSearches();
    context.setShowHistory(false);
  };

  const handleClick = (search: string) => {
    dispatch(setPrompt(search));
    context.setShowHistory(false);
  };

  return (
    <ResourcesNLPSearchBarHistoryWrapper data-id="resources-nlp-search-bar-history">
      <ResourcesNLPSearchBarHistoryClearButtonContainer>
        <ResourcesNLPSearchBarHistoryClearCTA onClick={handleClearHistory}>
          CLEAR HISTORY
        </ResourcesNLPSearchBarHistoryClearCTA>
      </ResourcesNLPSearchBarHistoryClearButtonContainer>
      <ResourcesNLPSearchBarHistoryList>
        {Object.keys(groupedSearches).map((date) => (
          <React.Fragment key={date}>
            <ResourcesNLPSearchBarHistoryItemDate>{date}</ResourcesNLPSearchBarHistoryItemDate>
            {groupedSearches[date].map((search, index) => (
              <ResourcesNLPSearchBarHistoryItem
                key={`${search.search}-${index}`}
                onClick={() => handleClick(search.search)}
              >
                <ClockRewindIcon />
                <ResourcesNLPSearchBarHistoryItemLabel>
                  {search.search}
                </ResourcesNLPSearchBarHistoryItemLabel>
              </ResourcesNLPSearchBarHistoryItem>
            ))}
          </React.Fragment>
        ))}
      </ResourcesNLPSearchBarHistoryList>
    </ResourcesNLPSearchBarHistoryWrapper>
  );
}
